import React from 'react'

function Textile() {
  return (
    <div>Textile</div>
  )
}

export default Textile